import { ChangeDetectorRef, Component, signal } from '@angular/core';
import { Subject, Subscription, takeUntil, timer } from 'rxjs';
import { ToastService } from './shared/services';
import { MessageToastConfig, TOAST_KEYS } from './shared/models';
import { ForceAny } from './shared/typescript';
import { LoaderService } from './core/services';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'ats';
  readonly toastKeys = TOAST_KEYS;
  showTimeoutMessage = false;
  loaderMessage = signal<string>('');
  loaderTimeout: ForceAny;
  loading = false;

  toastConfig: MessageToastConfig = {
    position: 'top-right',
    key: this.toastKeys.default,
  };

  $subscription = new Subscription();
  private destroy$ = new Subject<void>();

  constructor(
    public toastService: ToastService,
    public loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.listenMessageObserver();
    this.listenLoaderObserver();

    this.$subscription.add(
      this.loaderService.loaderMessage.subscribe((message) => {
        this.loaderMessage.set(message);
      }),
    );
  }

  listenLoaderObserver() {
    this.$subscription.add(
      this.loaderService.isLoaderVisible.subscribe((res) => {
        this.loading = res;
        if (this.loaderTimeout) {
          clearTimeout(this.loaderTimeout);
        }
        if (res) {
          this.loaderTimeout = setTimeout(() => {
            if (this.loading) {
              this.showTimeoutMessage = true;
            }
          }, 30000); // 30 seconds
        } else {
          // If loading is false, reset the timeout message
          this.showTimeoutMessage = false;
        }

        this.cdr.detectChanges();
      }),
    );
  }

  listenMessageObserver() {
    this.$subscription.add(
      this.toastService.$toastChange.subscribe((res) => {
        if (res) this.toastConfig = { ...res };
      }),
    );
  }

  handleAction(action: 'accept' | 'reject', event: ForceAny) {
    this.toastService.messageService.clear();
    this.toastService.closeToast();
    timer(300)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (action === 'accept' && this.toastConfig?.onConfirm) {
          this.toastConfig.onConfirm(event);
        } else if (this.toastConfig?.onReject) {
          this.toastConfig.onReject(event);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.$subscription.unsubscribe();
  }
}
